export default [
  {
    path: '/admin/adDebugger',
    name: 'ad-debugger',
    component: () => import('@/views/admin/ad-debugger/AdDebugger.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.AdDebugger',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.AdDebugger',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/scoring/debug',
    name: 'admin-scoring-debug',
    component: () => import('@/views/admin/ad-debugger/ScoreDebugger.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.ScoreDebugger',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.ScoreDebugger',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/RenderDebugger',
    name: 'admin-render-debug',
    component: () => import('@/views/admin/ad-debugger/RenderDebugger.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.RenderDebugger',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.RenderDebugger',
          active: true,
        },
      ],
    },
  },
]
